<template>
  <div class="project" v-if="project.title">

    <transition  name="fadeSlide2" appear>
      <div class="overlay">
        <h2>{{project.title.rendered}}</h2>
        <h3>{{project.acf.description}}</h3>
      </div>
    </transition>

    <transition name="fadeSlide" appear><div class="featuredImage" :style="`background-image : url('${project.acf.image1.url}')`">
    </div></transition>
    <div class="demandeOverlay overlay">
      <div id="demande" class="demande">
        <span class="projectPartTitle">Demande :</span> {{project.acf.demande}}
      </div>

      <div class="row imageRow sm-block">
        <div class="photo2 col-6 col-sm-12" :style="`background-image : url('${project.acf.image2.url}')`">
        </div>
        <div class="photo3 col-6 col-sm-12" :style="`background-image : url('${project.acf.image3.url}')`">
        </div>

      </div>
    </div>

    <div class="challengeOverlay overlay">
    <div class="challenge col-9 col-sm-12">
      <span class="projectPartTitle">Challenge :</span> {{project.acf.challenge}}
    </div>
    <div class="stopfloat">

    </div>


      <div class="row imageRow-fullwidth ">
        <div class="col-6  photo4" :style="`background-image : url('${project.acf.image4.url}')`">
        </div>

        <div class="col-6  photo7" v-if="project.acf.image7" :style="`background-image : url('${project.acf.image7.url}')`">

        </div>
        <div class="col-6 col-sm-12 photo7" v-else>
          <video :src="project.acf.video1" autoplay muted loop>

          </video>
        </div>

      </div>
    </div>

    <div class="realisationOverlay overlay">
      <div class="realisation">
        <span class="projectPartTitle">Réalisation :</span> {{project.acf.realisation}}
      </div>

<div class="lastPhotos">
      <div class="photo8" v-if="project.acf.image8">
        <img :src="project.acf.image8.url" :alt="project.acf.image8.description">
      </div>
      <div class="photo8" v-else>
        <video :src="project.acf.video2" autoplay muted loop>

        </video>
      </div>

      <div class="row sm-block">
        <div class="photo5 col-6 col-sm-12">
          <img :src="project.acf.image5.url" :alt="project.acf.image5.description">
        </div>

        <div class="photo6 col-6 col-sm-12">
          <img :src="project.acf.image6.url" :alt="project.acf.image6.description">
        </div>
      </div>
    </div>
    </div>




  </div>
</template>

<script>

import axios from 'axios'
export default {
  components: {

  },
  data:function(){
    return {
      project:{}

    }
  },
  mounted(){

    axios
    .get(`https://www.nicolas-noel.net/api/index.php/wp-json/wp/v2/posts?slug="${this.$route.params.slug}"`)
    .then(response => (response.data.length > 0 ? this.project = response.data[0] : this.$router.push('/')))
    .then(()=>{
      let revealTldemande = new TimelineMax()
      revealTldemande.from('.demande', 1, {
        y: '100%', opacity:0,
        ease: Expo.easeOut
      });
      revealTldemande.from('.imageRow', 1, {
        opacity:0,
        ease: Expo.easeOut
      },"-=1");
      // Declare Scene
      const demande = this.$scrollmagic.scene({
        // ID of element where animation starts
        triggerElement: '.demandeOverlay',

        // {0,0.5,1} - animations starts from {top,center,end} of window
        triggerHook: 0.9

        // Duration of animation
        // duration: 300

      })
      // Declaration of animation and attaching to element
      .setTween( revealTldemande)


      // Add Scene to controller
      this.$scrollmagic.addScene(demande)


      let revealTlchallenge = new TimelineMax()
      revealTlchallenge.from('.challenge', 1, {
        y: '100%', opacity:0,
        ease: Expo.easeOut
      });
      revealTlchallenge.from('.imageRow-fullwidth', 1, {
        opacity:0,
        ease: Expo.easeOut
      },"-=1");
      // Declare Scene
      const challenge = this.$scrollmagic.scene({
        // ID of element where animation starts
        triggerElement: '.challengeOverlay',

        // {0,0.5,1} - animations starts from {top,center,end} of window
        triggerHook: 0.9
        // Duration of animation
        // duration: 300

      })
      // Declaration of animation and attaching to element
      .setTween( revealTlchallenge)


      // Add Scene to controller
      this.$scrollmagic.addScene(challenge)


      let revealTlrealisation = new TimelineMax()
      revealTlrealisation.from('.realisation', 1, {
        y: '100%', opacity:0,
        ease: Expo.easeOut
      });
      revealTlrealisation.from('.lastPhotos', 1, {
        opacity:0,
        ease: Expo.easeOut
      },"-=1");
      // Declare Scene
      const realisation = this.$scrollmagic.scene({
        // ID of element where animation starts
        triggerElement: '.realisationOverlay',

        // {0,0.5,1} - animations starts from {top,center,end} of window
        triggerHook: 0.9

        // Duration of animation
        // duration: 300

      })
      // Declaration of animation and attaching to element
      .setTween( revealTlrealisation)


      // Add Scene to controller
      this.$scrollmagic.addScene(realisation)






    }



)






}

}
</script>


<style scoped>



.project{
  padding-top: 12.5rem;
}

h2,h3{
  padding-left: 7.5rem;
}

h3{
  padding-top: 1rem;
  margin-bottom: 2.5rem;
}

.featuredImage{
  margin: auto;
  width: calc(100% - 14rem);
  height: 100vh;

}

.photo2, .photo3, .photo4, .featuredImage{
  background-size: cover;
  background-position: center;
}

.demande, .challenge, .realisation{
  font-size: 1.5rem;
  font-family: 'Cormorant', serif;
  color: #222;
  /* margin-top: 6.25rem 0 6.25rem 0; */
  padding: 6.25rem 7.5rem 6.25rem 7.5rem;
  line-height: 2.25rem;
}

.projectPartTitle{
  font-size: 1.5rem;
  text-transform: uppercase;
  color: #555;
  font-family: 'Poppins', sans-serif;
}

.imageRow{
  padding: 0 7.5rem 0 7.5rem;
  height: 100vh;

}

.challenge{
  float: right;
  text-align: right;
}

.stopfloat{
  clear: both;
}

.imageRow-fullwidth{
  height: 100vh;

}

.photo7{
  height: 100vh;
  background-size: cover;
  background-position: center;
}

.photo7 img{

}

.photo8 img, .photo8 video, .photo5 img, .photo6 img{
  width: 100%;
}

.fadeSlide-enter-active, .fadeSlide-leave-active {
  transition: 1s;
  transition-delay: 1s;

}
.fadeSlide-enter, .fadeSlide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-100%);
}

.fadeSlide2-enter-active, .fadeSlide2-leave-active {
  transition: 1s;
  transition-delay: 1s;

}
.fadeSlide2-enter, .fadeSlide2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(-100%);
}

.width-enter-active, .width-leave-active {
  transition: 1s;
  transition-delay: 1s;

}
.width-enter, .width-leave-to /* .fade-leave-active below version 2.1.8 */ {
  width:0;
}

@media all and (max-width: 736px) {

  .sm-block{
    display: block;
  }

  h2,h3{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .demande, .challenge, .realisation{
    padding: 6.25rem 4rem 6.25rem 4rem;
    font-size: 2rem;
    line-height: 3rem;
  }

  .photo2, .photo3, .photo4, .photo7{
    height: 50vh;
  }

  .photo4, .photo7{
    height: 50vh;
  }



   .featuredImage{
    padding: 0;
    height: 50vh;
    width: 100%;
  }

    .imageRow {
          padding: 0;
              width: 100%;
    }

  .imageRow-fullwidth{
    height: 50vh;
  }


}
</style>
